import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewIndex = () => import('./index')

Vue.use(Router)

const router =
  [
    {
      path: '/a/staff',
      component: DefaultContainer,
      children: [
        {
          path: 'configurate',
          name: 'A_StaffConfigurate',
          component: ViewIndex,
          beforeEnter: Permisos.IS_ADMIN,
          meta: {
            title: 'Staff',
          }                    
        },
      ]
    },
  ]

export default router
